import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { trackEvent } from "../lib/appInsights";

export const HelpModal = ({
  show,
  onClose,
  jwtRef,
  internalQuestionnaireId
}) => {
  const [form, setForm] = useState({ name: "", email: "", description: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);



  
  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);

    try {
      const api = axios.create({
        headers: { Authorization: `Bearer ${jwtRef.current}` },
      });

      await api.post("/api/helpRequest", {
        questionnaireId: internalQuestionnaireId,
        ...form,
      });

      trackEvent('HelpRequested');
      setSubmitted(true);
      setSubmitting(false);

      setTimeout(() => {
      onClose(); // Just call close. The onExited prop will handle the rest.
    }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send request. Please try again.");
      setSubmitting(false);
    }
  };


  const handleExited = () => {
    setSubmitted(false);
    setForm({ name: "", email: "", description: "" });
    setError(null);
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" onExited={handleExited}>
      <Modal.Header closeButton>
        <Modal.Title>Need Help?</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!submitted ? (
          <>
            <p>
              Please describe any issue(s) you are experiencing with the questionnaire or its questions.
              Our Sales team will review your submission and respond shortly.
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="helpDescription">
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  placeholder="Describe the issue..."
                />
              </Form.Group>
            </Form>

            {error && <div className="text-danger">{error}</div>}
          </>
        ) : (
          <div className="text-center py-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <p className="mt-3">Thank you! Your request has been sent.</p>
          </div>
        )}
      </Modal.Body>

      {!submitted && (
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={submitting || !form.description.trim()}
          >
            {submitting ? "Sending..." : "Send to Sales Team"}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default HelpModal;
